import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=46876e4e&"
import script from "./FlagIcon.vue?vue&type=script&lang=js&"
export * from "./FlagIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports